import { apiCall } from "../../store/services/service";
import { BASE_URL, URL_RESOURCE_DUTY_ROSTER_REPORT } from "../../store/services/URL";
import { abortableRequest } from "../../helpers/abortableRequest";

const resourcePlannerService = {
  /**
   * PUT /tasks/{taskId}/allocations/{resourceId}
   * Resolves with the full response; the body is a `Result` envelope that must be read through `unwrapResult`.
   * @param {string} taskId
   * @param {string} resourceId
   * @param {Object} body - { startDate, endDate }
   */
  updateAllocation(taskId, resourceId, body) {
    return abortableRequest({
      method: "put",
      url: `${BASE_URL}tasks/${taskId}/allocations/${resourceId}`,
      data: body,
    });
  },

  /**
   * POST /resources/duty-roster/report
   * @param {Object} payload - { ProjectId, StartDate?, EndDate?, ViewType, ShowWeekend, ShowUtilization, ShowAllocation, Resources? }
   */
  getDutyRosterReport(payload) {
    return apiCall.pdfPost({
      url: URL_RESOURCE_DUTY_ROSTER_REPORT,
      params: payload,
    });
  },
};

export default resourcePlannerService;
